import { scheduleConstants } from '../../_constants';

export function voyageSchedule(state = {}, action) {
    switch (action.type) {
        case scheduleConstants.SCHEDULE_FETCHING:
            return {
                ...state,
                scheduleFetching: true
            };
        case scheduleConstants.SCHEDULE_FETCHED:
            return {
                ...state,
                scheduleFetching: false
            };
        case scheduleConstants.SCHEDULE_SUBMITTING:
            return {
                ...state,
                scheduleSubmitting: true
            };
        case scheduleConstants.SCHEDULE_SUBMITTED:
            return {
                ...state,
                scheduleSubmitting: false
            };
        case scheduleConstants.LIST_OF_SCHEDULES:
            return {
                ...state,
                schedules: action.schedules
            };
        case scheduleConstants.GET_SCHEDULE_BY_ID:
            return {
                ...state,
                schedule: action.schedule
            };
        case scheduleConstants.DESTINATIONS_LIST_FROM_SCHEDULE:
            return {
                ...state,
                destinationsFromSchedule: action.destinationsFromSchedule
            };
        default:
            return state;
    }
}